export const NAV_LINKS = [
  { label: "独家调查", href: "#deep" },
  { label: "分类爆料", href: "#category" },
  { label: "来源链条", href: "#source" },
  { label: "知情与狗仔", href: "#insiders" },
  { label: "关于我们", href: "#about" },
  { label: "常见问题", href: "#faq" },
];

export const CATEGORIES = [
  {
    key: "contract",
    name: "合约内幕",
    en: "CONTRACT",
    icon: "ri-file-shield-2-line",
    desc: "片酬分成、对赌条款、解约博弈，拆解白纸黑字背后的真实筹码。",
  },
  {
    key: "talent",
    name: "经纪真相",
    en: "AGENCY",
    icon: "ri-hand-heart-line",
    desc: "艺人定位、资源置换与商务谈判，明星台前风光背后的经纪操盘。",
  },
  {
    key: "reality",
    name: "综艺幕后",
    en: "VARIETY",
    icon: "ri-clapperboard-line",
    desc: "剧本设定、剪辑取舍与流量指标，综艺镜头里外并不一致的现场。",
  },
  {
    key: "filming",
    name: "剧组现场",
    en: "ONSET",
    icon: "ri-movie-2-line",
    desc: "拍摄周期的加班、改戏与失控，片场真实的秩序与混乱。",
  },
  {
    key: "dark",
    name: "行业黑幕",
    en: "INSIDE",
    icon: "ri-skull-2-line",
    desc: "数据造假、饭圈集资与灰色公关，触达产业链里不愿被看见的一环。",
  },
];

export const DEEP_STORIES = [
  {
    no: "01",
    category: "独家调查",
    duration: "6 周深度跟踪",
    title: "一纸对赌协议，如何改变了顶流小生的整个职业轨迹",
    excerpt:
      "我们在三个城市、四位知情人士的交叉印证下，还原一份被反复修订的业绩对赌条款，看它如何反过来重塑一名艺人的选戏逻辑与公关口径。",
    tag: "对赌协议",
    readTime: "12 分钟深度",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20moody%20editorial%20scene%20of%20a%20stack%20of%20signed%20paper%20contracts%20with%20a%20fountain%20pen%20on%20a%20dark%20wood%20desk%2C%20warm%20amber%20desk%20lamp%20glow%2C%20deep%20red%20accent%20shadow%2C%20film%20noir%20lighting%2C%20mysterious%20investigative%20mood&seq=deep-contract&width=1200&height=800&orientation=landscape",
  },
  {
    no: "02",
    category: "幕后拆解",
    duration: "多方交叉核实",
    title: "那场‘突然缺席’的红毯，背后的改期通知其实是三层博弈",
    excerpt:
      "从站姐的路透到官方的行程取消，从品牌方档期到对家通稿——我们把同一条热搜拆成四份相互矛盾的时间线，看清谁在带节奏、谁在收尾。",
    tag: "红毯博弈",
    readTime: "9 分钟阅读",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20shot%20of%20an%20empty%20red%20carpet%20between%20velvet%20ropes%20under%20dramatic%20spotlights%2C%20backstage%20corridor%20glow%2C%20dark%20moody%20tones%20with%20crimson%20light%2C%20mysterious%20press%20event%20atmosphere&seq=deep-redcarpet&width=1200&height=800&orientation=landscape",
  },
  {
    no: "03",
    category: "数据拆真",
    duration: "抽样比对",
    title: "一张‘爆款’播放量破亿的海报，背后的真实水分有几成",
    excerpt:
      "我们把同一时段、同一部剧的脱水曲线和营销口径并排放在一起，用可复现的抽样方法，讲清楚数据是怎样被‘注水’又是怎样被戳破的。",
    tag: "播放量水分",
    readTime: "8 分钟阅读",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20visualization%20of%20glowing%20data%20charts%20and%20numbers%20floating%20above%20a%20dark%20control%20room%20monitor%2C%20red%20and%20amber%20dashboard%20lights%2C%20moody%20tech%20noir%20aesthetic%2C%20mysterious%20analytics%20atmosphere&seq=deep-data&width=1200&height=800&orientation=landscape",
  },
];

export const SOURCE_CHAIN = [
  {
    step: "01",
    role: "知情人士",
    title: "第一手信源",
    color: "bg-primary-500",
    desc: "身处剧组、经纪公司或品牌方内部的人，最先掌握可被验证的原始信息，是整条链条的起点。",
  },
  {
    step: "02",
    role: "狗仔与线人",
    title: "线索与画面",
    color: "bg-accent-500",
    desc: "通过长期蹲点与实地记录，把‘听说’变成有时间、地点和画面的可视线索。",
  },
  {
    step: "03",
    role: "娱乐记者",
    title: "交叉核实",
    color: "bg-secondary-600",
    desc: "用多方信源对照、向涉事方求证、核查原始材料，去伪存真，判断哪些能够发布。",
  },
  {
    step: "04",
    role: "编辑部",
    title: "来源判定与发布",
    color: "bg-foreground-800",
    desc: "标注信源可信度、保留证据链，在真实与审慎之间给出可追溯的报道。",
  },
];

export const INSIDER_ROLES = [
  {
    icon: "ri-user-heart-line",
    role: "知情人士",
    color: "text-primary-600",
    bg: "bg-primary-100",
    title: "他们为什么开口",
    desc: "有人为还原事实，有人为自己发声，也有人希望行业变得更透明。保护信源是我们合作的前提。",
    points: ["匿名与加密沟通", "材料可交叉核验", "信源身份分级保护"],
  },
  {
    icon: "ri-camera-lens-line",
    role: "狗仔现场",
    color: "text-accent-700",
    bg: "bg-accent-100",
    title: "镜头外的跟踪逻辑",
    desc: "长期蹲守、路线复盘与时间差捕捉，狗仔提供的画面常是调查里最直观的锚点。",
    points: ["实地影像取证", "时间线复原", "与通稿互相比对"],
  },
  {
    icon: "ri-edit-circle-line",
    role: "记者手记",
    color: "text-secondary-700",
    bg: "bg-secondary-100",
    title: "一条稿子如何出街",
    desc: "从线索登记、信源确认、法务审校到发布口径，编辑部有一套完整的把关流程。",
    points: ["三源核实原则", "涉事方给足回应窗口", "保留原始证据"],
  },
];

export const SOURCE_TABS = ["知情人士", "狗仔线索", "记者报道", "官方回应"] as const;
export type SourceTab = (typeof SOURCE_TABS)[number];

export const NEWS = [
  {
    title: "某热播综艺收官夜，制片组内部复盘会内容被爆料流出",
    source: "知情人士",
    tag: "综艺幕后",
    time: "38 分钟前",
    reads: "12.6万",
    summary:
      "一位参与现场的节目组成员透露，收官夜的‘反转结局’其实备了三套方案，最终选哪版由数据部门临时拍板。",
  },
  {
    title: "一线小花被曝深夜仍在小城片场赶大夜戏，连轴拍摄已超四周",
    source: "狗仔线索",
    tag: "剧组现场",
    time: "1 小时前",
    reads: "9.3万",
    summary: "连续多日的蹲点画面显示，该剧为保证进度多次压缩调整休息时间，现场主创情绪明显疲惫。",
  },
  {
    title: "经纪人圈在聊：一次资源置换，到底能‘贴’多少商务条件",
    source: "记者报道",
    tag: "经纪真相",
    time: "2 小时前",
    reads: "7.8万",
    summary: "多位不愿具名的经纪人向记者描述了一场典型置换交易的结构，条款远比外界想象的复杂。",
  },
  {
    title: "官方回应‘演员变动’传闻：以官宣为准，其余不便置评",
    source: "官方回应",
    tag: "合约内幕",
    time: "3 小时前",
    reads: "5.4万",
    summary: "针对外界流传的角色更替与档期冲突，出品方发布简短声明，呼吁以正式公告口径为准。",
  },
  {
    title: "站姐投稿：某位流量艺人演唱会后的庆功宴，被拍到全程未离席",
    source: "知情人士",
    tag: "经纪真相",
    time: "5 小时前",
    reads: "8.9万",
    summary: "参与筹备的工作人员透露，庆功宴的宾客名单与座位安排历经三轮修改，安抚情绪是当晚重点。",
  },
  {
    title: "一份流出的选角表显示：多位演员候选名单被反复圈改",
    source: "狗仔线索",
    tag: "剧组现场",
    time: "6 小时前",
    reads: "6.2万",
    summary: "摄影师私下拍到的剧本改动图里，角色的备选方案标注密密麻麻，开机前仍在调整。",
  },
  {
    title: "数据岗位员工爆料：凌晨‘补量’已成为部分榜单的默认操作",
    source: "知情人士",
    tag: "行业黑幕",
    time: "8 小时前",
    reads: "15.1万",
    summary: "多位前平台运营人员向记者描述了榜单冲击的常规时段与方法，质疑算法能否真正识别水分。",
  },
  {
    title: "记者核实：那则‘含沙射影’的声明，其实有两个版本",
    source: "记者报道",
    tag: "行业黑幕",
    time: "9 小时前",
    reads: "4.7万",
    summary: "我们对比了两个文件版本间的措辞差异，发现关键一句在内部审校中被整体替换。",
  },
];

export const TICKER_ITEMS = [
  "知情人士爆料某剧组为赶进度连轴拍摄四周",
  "流出的选角表显示角色候选名单被反复圈改",
  "数据岗位员工称凌晨补量已成榜单默认操作",
  "经纪人圈热议一次资源置换的商务条件构成",
  "官方回应演员变动传闻：以官宣为准",
  "收官夜复盘会爆料：结局其实备了三套方案",
];

export const TESTIMONIALS = [
  {
    name: "阿哲",
    meta: "追综十年观众",
    text: "看了这里的综艺幕后拆解，才发现我之前信了很多片面的‘爆料’。它把每一条说法都标了来源，读起来踏实。",
  },
  {
    name: "KK",
    meta: "娱乐行业从业者",
    text: "关于合约和经纪运作的专栏很专业，站在从业者角度能对上一半的行业黑话，很多内容真话不多见。",
  },
  {
    name: "Momo",
    meta: "站姐 / 图片分享者",
    text: "平台强调信源分级和匿名保护，我愿意把拍到的时间线投稿过去，能感觉到编辑是真的在认真对待每一份素材。",
  },
];

export const PRINCIPLES = [
  { icon: "ri-focus-3-line", title: "信源优先", desc: "每条重磅先问三个问题：谁说的、能否验证、为何现在说。" },
  { icon: "ri-scales-3-line", title: "给足窗口", desc: "涉及当事方的报道，一定先给回应与澄清的机会，再下结论。" },
  { icon: "ri-history-line", title: "保留证据", desc: "截图、音画、时间线全程留档，让每一条结论都可被回溯。" },
  { icon: "ri-shield-user-line", title: "保护线人", desc: "匿名沟通与身份分级，让敢说真话的人不必付出代价。" },
];

export const FAQS = [
  {
    q: "爆源娱乐的信源主要来自哪里？",
    a: "我们的内容来源多元，包括剧组、经纪与品牌方内部人士提供的匿名线索，长期蹲点的现场影像，以及记者对多方说法进行的交叉核实。每一类信息在发布时都会标注信源类型，方便读者自行判断可信度。",
  },
  {
    q: "如何区分‘确凿’与‘传闻’级别的爆料？",
    a: "我们用明确的标识进行分级：经多方独立信源验证并留有原始材料的内容标注为‘已核实’；仅来自单一渠道、尚未获得独立印证的说法会明确提示‘待证’。读者可以据此理解信息的确凿程度，避免被单一说法误导。",
  },
  {
    q: "我掌握行业信息，如何匿名向你们投稿？",
    a: "你可以通过页面底部‘深挖线索’栏目提交线索，我们支持完全匿名沟通，也可在后续使用加密渠道交换更敏感的材料。编辑会先确认你的信息是否具备独立验证的可能，再决定是否跟进。",
  },
  {
    q: "为什么很多内容只写‘某艺人’而不直接点名？",
    a: "在信源身份分级、涉事方尚未回应或证据链尚不完整时，我们优先采用化名与模糊处理，避免伤害当事人的名誉权。当证据足够充分且经过审校后，我们才会进一步披露具体信息。",
  },
  {
    q: "报道与商业合作之间如何保持独立？",
    a: "编辑部内容与商务合作严格分离。凡涉及广告、赞助或联名的内容都会显著标注‘合作’字样，编辑对选题与结论保留完全独立决定权，不因商业关系改变报道方向。",
  },
];

export const STATS = [
  { num: "1200+", label: "累积跟踪选题" },
  { num: "86%", label: "信源交叉核实率" },
  { num: "37", label: "常驻知情线人" },
  { num: "2019", label: "成立于该年" },
];